import { render, staticRenderFns } from "./individuals.vue?vue&type=template&id=6caa6c54&"
import script from "./individuals.vue?vue&type=script&lang=js&"
export * from "./individuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports